import React from 'react';
import Button from './Button';
import { Link } from 'react-router-dom';

interface FeatureToggleButtonProps {
  isFeatureEnabled: boolean;
  className?: string;
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'outline';
  link: string;
  linkClassName?: string;
}

const FeatureToggleButton: React.FC<FeatureToggleButtonProps> = ({ isFeatureEnabled, link, linkClassName, className, text, size, variant }) => {
  if (!isFeatureEnabled) {
    return null;
  }

  return (
      <Link to={link} className={linkClassName}>
        <Button variant={variant} size={size} className={className}>
            {text}
        </Button>
      </Link>
  );
};

export default FeatureToggleButton;